import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { useTranslation } from "@coworker/locales";
import { NoSearchResults } from "../NoSearchResults/NoSearchResults";
import { Loading } from "../Loading/Loading";

type TeamsListProps = {
  matchingTeams: StoreTeam[];
  isLoading: boolean;
  myTeamId?: string | undefined;
  searchQuery: string;
  assignedTeamId: string | null;
  onTeamIdChange: (teamId: string) => void;
  onSearchForCoworkersClick: () => void;
  onClearSearchClick: () => void;
};

export const TeamsList = (props: TeamsListProps) => {
  const { t } = useTranslation();

  return props.isLoading ? (
    <Loading />
  ) : (
    <FixaListView id="teams">
      {props.matchingTeams.map((team) => (
        <FixaListViewItem
          key={team.id}
          emphasised
          title={team.name}
          description={
            team.id === props.myTeamId ? t("myCurrentTeamString") : ""
          }
          control="radiobutton"
          controlProps={{
            checked: team.id === props.assignedTeamId,
            value: team.id,
          }}
          onChange={() => props.onTeamIdChange(team.id)}
        />
      ))}
      {props.matchingTeams.length === 0 && (
        <NoSearchResults
          searchQuery={props.searchQuery}
          searchTarget={t("coworkersString")}
          onSearchForClick={props.onSearchForCoworkersClick}
          clearSearch={props.onClearSearchClick}
        />
      )}
    </FixaListView>
  );
};
